import React from 'react';

import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Button, Table, Card, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
const { RangePicker } = DatePicker;

const gridStyle = {
  width: '25%',
  textAlign: 'center',
};

class TablaPedidos extends React.Component {
  generarOpciones = detalle => {
    return (
      <Card.Grid key={detalle.tipo_sello._id} style={gridStyle}>
        {detalle.tipo_sello.nombre + ': ' + detalle.cantidad}
      </Card.Grid>
    );
  };

  render() {
    const colums = [
      {
        title: 'N°',
        dataIndex: 'numero',
      },
      {
        title: 'Fecha',
        dataIndex: 'fechaPedido',
        render: fecha => (fecha ? moment(fecha).format('DD/MM/YYYY') : ''),
      },
      {
        title: 'Organismo',
        dataIndex: 'organismo.nombre',
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        filters: [
          { text: 'PENDIENTE', value: 'PENDIENTE' },
          { text: 'COMPLETADO', value: 'COMPLETADO' },
        ],
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            {record.estado == 'PENDIENTE' && (
              <Button
                style={{ marginLeft: 5 }}
                size="small"
                type="primary"
                icon={<Icons.SolutionOutlined />}
                onClick={() => this.props.generarEnvio(record)}
              >
                Generar
              </Button>
            )}
            {record.estado == 'PENDIENTE' && (
              <Button
                style={{ marginLeft: 5 }}
                size="small"
                icon={<Icons.SaveOutlined />}
                onClick={() => this.props.archivarPedido(record._id)}
              >
                Completar
              </Button>
            )}
            <Button
              style={{ marginLeft: 5 }}
              size="small"
              type="danger"
              icon={<Icons.EditOutlined />}
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    return (
      <div>
        <Table
          bordered
          pagination={false}
          style={{ maxWidth: 1200, marginTop: 20 }}
          dataSource={this.props.data}
          rowKey={'_id'}
          columns={colums}
          onChange={this.props.handleTableChange}
          title={() => (
            <div>
              <h2 style={{ textAlign: 'center' }}> Tabla de Pedidos </h2>
              <div style={{ textAlign: 'center' }}>
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <h3>PERIODO DE FECHAS:</h3>
                  </Col>
                  <Col>
                    <RangePicker
                      style={{ width: 500, marginLeft: 10 }}
                      onChange={this.props.onChange}
                      defaultValue={[moment().subtract(7, 'd'), moment()]}
                      format={'DD-MM-YYYY'}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )}
          locale={{
            emptyText: 'Sin datos de pedidos.',
          }}
          /* expandedRowRender={record => _.map(record.detalle, detalle => {
            return <p key={detalle.tipo_sello._id} style={{ margin: 0, fontFamily: "arial", fontSize: 18}}>{detalle.tipo_sello.nombre + ": " + detalle.cantidad}</p>
          })} */
          expandedRowRender={record =>
            record._id && (
              <Card key={record._id}>
                {_.map(record.detalle, detalle => {
                  return this.generarOpciones(detalle);
                })}
              </Card>
            )
          }
        />
      </div>
    );
  }
}

export default TablaPedidos;
